export enum SEO {
  ROOT = 'root',
  SPORTS_DEFAULT = 'sports.default',
}

export enum SEO_SPORT_URL {
  FOOTBALL = 'football',
  TENNIS = 'tennis',
  HORSE_RACING = 'horse-racing',
  CRICKET = 'cricket',
  RUGBY = 'rugby',
  DARTS = 'darts',
  SNOOKER = 'snooker',
  BOXING = 'boxing',
  MMA = 'mma',
  BASKETBALL = 'basketball',
  ICE_HOCKEY = 'ice-hockey',
  AMERICAN_FOOTBALL = 'american-football',
  GREYHOUNDS = 'greyhounds',
  TABLE_TENNIS = 'table-tennis',
  BASEBALL = 'baseball',
  VOLEYBALL = 'voleyball',
  GOLF = 'golf',
  F1 = 'f1',
  E_LEAGUES = 'e-leagues',
  E_FOOTBALL = 'e-football',
  E_BASKETBALL = 'e-basketball',
}
